/* tslint:disable */
/* eslint-disable */
/**
 * SLM API used by SLM frontend
 * This is the specification of the backend APIs. The main purpose of this specification is to unify the API between SLM-backend and SLM-frontend. For localizations the Accept-Language header is used.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dl.mhs.bd3.se@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type DefaultParameterDto,
    DefaultParameterDtoFromJSON,
    DefaultParameterDtoToJSON,
} from '../models/DefaultParameterDto';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type ItemParameterDto,
    ItemParameterDtoFromJSON,
    ItemParameterDtoToJSON,
} from '../models/ItemParameterDto';
import {
    type PaginatedItemParameterDto,
    PaginatedItemParameterDtoFromJSON,
    PaginatedItemParameterDtoToJSON,
} from '../models/PaginatedItemParameterDto';
import {
    type ParameterDto,
    ParameterDtoFromJSON,
    ParameterDtoToJSON,
} from '../models/ParameterDto';
import {
    type ParameterHistory,
    ParameterHistoryFromJSON,
    ParameterHistoryToJSON,
} from '../models/ParameterHistory';
import {
    type ParameterLimits,
    ParameterLimitsFromJSON,
    ParameterLimitsToJSON,
} from '../models/ParameterLimits';

export interface GetDefaultParametersRequest {
    /**
     * Business Unit Code
     */
    buCode: string;
}

export interface GetF6ParametersRequest {
    /**
     * Business Unit Code
     */
    buCode: string;
}

export interface GetParameterHistoryRequest {
    /**
     * Business Unit Code
     */
    buCode: string;
    /**
     * 
     */
    filter: GetParameterHistoryFilterEnum;
    /**
     * 
     */
    filterValue: string;
    /**
     * Restricts the list to changes for this parameter
     */
    paramId?: string;
}

export interface GetParameterValueLimitsRequest {
    /**
     * Business Unit Code
     */
    buCode: string;
    /**
     * Level type
     */
    filter: GetParameterValueLimitsFilterEnum;
    /**
     * Level ID
     */
    filterValue: string;
}

export interface GetParametersForItemsRequest {
    /**
     * Business Unit Code
     */
    buCode: string;
    /**
     * Level type
     */
    filter: string;
    /**
     * Level ID
     */
    filterValue: string;
    /**
     * Parameter ID
     */
    parameter: string;
    /**
     * Number of the requested page, first page is pageNr='1'
     */
    pageNr?: number;
    /**
     * Size of the requested page
     */
    pageSize?: number;
}

export interface GetParametersForSingleItemRequest {
    /**
     * Business Unit Code
     */
    buCode: string;
    /**
     * Item number
     */
    itemNo: string;
}

/**
 * 
 */
export class GETParametersApi extends runtime.BaseAPI {

    /**
     * Creates request options for getDefaultParameters without sending the request
     */
    async getDefaultParametersRequestOpts(requestParameters: GetDefaultParametersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['buCode'] == null) {
            throw new runtime.RequiredError(
                'buCode',
                'Required parameter "buCode" was null or undefined when calling getDefaultParameters().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("slmUserBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/parameters/v1/{buCode}/defaults`;
        urlPath = urlPath.replace('{buCode}', encodeURIComponent(String(requestParameters['buCode'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Gets the defualt parameter and their values
     * Gets the parameters and their values on store, division and HFB level
     */
    async getDefaultParametersRaw(requestParameters: GetDefaultParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DefaultParameterDto>> {
        const requestOptions = await this.getDefaultParametersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DefaultParameterDtoFromJSON(jsonValue));
    }

    /**
     * Gets the defualt parameter and their values
     * Gets the parameters and their values on store, division and HFB level
     */
    async getDefaultParameters(requestParameters: GetDefaultParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DefaultParameterDto> {
        const response = await this.getDefaultParametersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getF6Parameters without sending the request
     */
    async getF6ParametersRequestOpts(requestParameters: GetF6ParametersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['buCode'] == null) {
            throw new runtime.RequiredError(
                'buCode',
                'Required parameter "buCode" was null or undefined when calling getF6Parameters().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("slmUserBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/parameters/v1/{buCode}/f6`;
        urlPath = urlPath.replace('{buCode}', encodeURIComponent(String(requestParameters['buCode'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get the SLM F6 parameters for a store
     * Fetches all the SLM F6 parameters
     */
    async getF6ParametersRaw(requestParameters: GetF6ParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ParameterDto>>> {
        const requestOptions = await this.getF6ParametersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ParameterDtoFromJSON));
    }

    /**
     * Get the SLM F6 parameters for a store
     * Fetches all the SLM F6 parameters
     */
    async getF6Parameters(requestParameters: GetF6ParametersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ParameterDto>> {
        const response = await this.getF6ParametersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getParameterHistory without sending the request
     */
    async getParameterHistoryRequestOpts(requestParameters: GetParameterHistoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['buCode'] == null) {
            throw new runtime.RequiredError(
                'buCode',
                'Required parameter "buCode" was null or undefined when calling getParameterHistory().'
            );
        }

        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling getParameterHistory().'
            );
        }

        if (requestParameters['filterValue'] == null) {
            throw new runtime.RequiredError(
                'filterValue',
                'Required parameter "filterValue" was null or undefined when calling getParameterHistory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['filterValue'] != null) {
            queryParameters['filterValue'] = requestParameters['filterValue'];
        }

        if (requestParameters['paramId'] != null) {
            queryParameters['paramId'] = requestParameters['paramId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("slmUserBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/parameters/v1/{buCode}/history`;
        urlPath = urlPath.replace('{buCode}', encodeURIComponent(String(requestParameters['buCode'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns all changes within the last year of any paramter that match the filter as a list without pagination.
     * Fetches the history for all parameters that match the filter
     */
    async getParameterHistoryRaw(requestParameters: GetParameterHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ParameterHistory>>> {
        const requestOptions = await this.getParameterHistoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ParameterHistoryFromJSON));
    }

    /**
     * Returns all changes within the last year of any paramter that match the filter as a list without pagination.
     * Fetches the history for all parameters that match the filter
     */
    async getParameterHistory(requestParameters: GetParameterHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ParameterHistory>> {
        const response = await this.getParameterHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getParameterValueLimits without sending the request
     */
    async getParameterValueLimitsRequestOpts(requestParameters: GetParameterValueLimitsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['buCode'] == null) {
            throw new runtime.RequiredError(
                'buCode',
                'Required parameter "buCode" was null or undefined when calling getParameterValueLimits().'
            );
        }

        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling getParameterValueLimits().'
            );
        }

        if (requestParameters['filterValue'] == null) {
            throw new runtime.RequiredError(
                'filterValue',
                'Required parameter "filterValue" was null or undefined when calling getParameterValueLimits().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['filterValue'] != null) {
            queryParameters['filterValue'] = requestParameters['filterValue'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("slmUserBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/parameters/v1/{buCode}/limits`;
        urlPath = urlPath.replace('{buCode}', encodeURIComponent(String(requestParameters['buCode'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Gets value ranges allowed for parameters
     * Fetches all the items that match the filters
     */
    async getParameterValueLimitsRaw(requestParameters: GetParameterValueLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ParameterLimits>>> {
        const requestOptions = await this.getParameterValueLimitsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ParameterLimitsFromJSON));
    }

    /**
     * Gets value ranges allowed for parameters
     * Fetches all the items that match the filters
     */
    async getParameterValueLimits(requestParameters: GetParameterValueLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ParameterLimits>> {
        const response = await this.getParameterValueLimitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getParametersForItems without sending the request
     */
    async getParametersForItemsRequestOpts(requestParameters: GetParametersForItemsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['buCode'] == null) {
            throw new runtime.RequiredError(
                'buCode',
                'Required parameter "buCode" was null or undefined when calling getParametersForItems().'
            );
        }

        if (requestParameters['filter'] == null) {
            throw new runtime.RequiredError(
                'filter',
                'Required parameter "filter" was null or undefined when calling getParametersForItems().'
            );
        }

        if (requestParameters['filterValue'] == null) {
            throw new runtime.RequiredError(
                'filterValue',
                'Required parameter "filterValue" was null or undefined when calling getParametersForItems().'
            );
        }

        if (requestParameters['parameter'] == null) {
            throw new runtime.RequiredError(
                'parameter',
                'Required parameter "parameter" was null or undefined when calling getParametersForItems().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['filter'] != null) {
            queryParameters['filter'] = requestParameters['filter'];
        }

        if (requestParameters['filterValue'] != null) {
            queryParameters['filterValue'] = requestParameters['filterValue'];
        }

        if (requestParameters['parameter'] != null) {
            queryParameters['parameter'] = requestParameters['parameter'];
        }

        if (requestParameters['pageNr'] != null) {
            queryParameters['pageNr'] = requestParameters['pageNr'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("slmUserBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/parameters/v1/{buCode}/items`;
        urlPath = urlPath.replace('{buCode}', encodeURIComponent(String(requestParameters['buCode'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Gets the items that match the filters
     * Fetches all the items that match the filters
     */
    async getParametersForItemsRaw(requestParameters: GetParametersForItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedItemParameterDto>> {
        const requestOptions = await this.getParametersForItemsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedItemParameterDtoFromJSON(jsonValue));
    }

    /**
     * Gets the items that match the filters
     * Fetches all the items that match the filters
     */
    async getParametersForItems(requestParameters: GetParametersForItemsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedItemParameterDto> {
        const response = await this.getParametersForItemsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getParametersForSingleItem without sending the request
     */
    async getParametersForSingleItemRequestOpts(requestParameters: GetParametersForSingleItemRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['buCode'] == null) {
            throw new runtime.RequiredError(
                'buCode',
                'Required parameter "buCode" was null or undefined when calling getParametersForSingleItem().'
            );
        }

        if (requestParameters['itemNo'] == null) {
            throw new runtime.RequiredError(
                'itemNo',
                'Required parameter "itemNo" was null or undefined when calling getParametersForSingleItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("slmUserBearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/parameters/v1/{buCode}/item/{itemNo}`;
        urlPath = urlPath.replace('{buCode}', encodeURIComponent(String(requestParameters['buCode'])));
        urlPath = urlPath.replace('{itemNo}', encodeURIComponent(String(requestParameters['itemNo'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Gets the item and it\'s parameter values
     * Gets parameters and their values for the given item number
     */
    async getParametersForSingleItemRaw(requestParameters: GetParametersForSingleItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ItemParameterDto>> {
        const requestOptions = await this.getParametersForSingleItemRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ItemParameterDtoFromJSON(jsonValue));
    }

    /**
     * Gets the item and it\'s parameter values
     * Gets parameters and their values for the given item number
     */
    async getParametersForSingleItem(requestParameters: GetParametersForSingleItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ItemParameterDto> {
        const response = await this.getParametersForSingleItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetParameterHistoryFilterEnum = {
    F6: 'f6',
    Store: 'store',
    Division: 'division',
    Hfb: 'hfb',
    Item: 'item',
} as const;
export type GetParameterHistoryFilterEnum = typeof GetParameterHistoryFilterEnum[keyof typeof GetParameterHistoryFilterEnum];
/**
 * @export
 */
export const GetParameterValueLimitsFilterEnum = {
    Store: 'store',
    Division: 'division',
    SpecialityShop: 'speciality_shop',
    Hfb: 'hfb',
    RangeArea: 'range_area',
    ProductArea: 'product_area',
    SalesMethod: 'sales_method',
    ServiceClass: 'service_class',
    Item: 'item',
} as const;
export type GetParameterValueLimitsFilterEnum = typeof GetParameterValueLimitsFilterEnum[keyof typeof GetParameterValueLimitsFilterEnum];
